import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function queryInventorySnapshotApi() {
  const apiUrlTest = "/gateway/edi/product/query"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.InventorysnapshotqueryapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [
        [
          {
            key: "apiDocDesc.testUrl",
            value:
              "https://demo-sop.jtfulfillment.cn/gateway/edi/inventory/his/page"
          },
          {
            key: "apiDocDesc.proUrl",
            value:
              "https://sop.jtfulfillment.cn/gateway/edi/inventory/his/page"
          },
          { key: "customerid:", value: "CS001" },
          { key: "warehouseCode:", value: "SH.001" },
          { key: "itemCode:", value: "YL001" },
          { key: "eccompanyid:", value: "STANDARD" },
          {
            key: "KEY:",
            value: "MGY3MTU3M2M3NjYxN2RhNjc3NzM4MzM2Y2Q5ZjQ0ZWU="
          }
        ],
        [
          {
            key: "apiDocDesc.testUrlCn",
            value:
              "https://demo-openapi.jtfulfillment.cn/gateway/edi/inventory/his/page"
          },
          {
            key: "apiDocDesc.proUrlCn",
            value:
              "https://openapi.jtfulfillment.cn/gateway/edi/inventory/his/page"
          },
          { key: "customerid:", value: "UPFOS-TEST" },
          { key: "warehouseCode:", value: "SH.001" },
          { key: "itemCode:", value: "STZX0000001" },
          { key: "eccompanyid:", value: "UPFOS-TEST_PPL" },
          {
            key: "KEY:",
            value: "ZDZmNTM1NWE2ZDQ5NjU4Y2Q4YzY5YWIwZGRjZTEyMzE="
          }
        ]
      ],
      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "warehouseCode",
              type: "STRING",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.warehouseCodeDesc425"
            },
            {
              name: "customerid",
              type: "STRING",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.customeridDesc426"
            },
            {
              name: "itemCode",
              type: "STRING",
              require: "N",
              normal: "",
              describe: "apiDocDesc.itemCodeDesc427"
            },
            {
              name: "snapshotDate",
              type: "DATE",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.snapshotDateDesc428"
            },
            {
              name: "startPage",
              type: "INT",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.startPageDesc429"
            },
            {
              name: "pageSize",
              type: "INT",
              require: "N",
              normal: "",
              describe: "apiDocDesc.pageSizeDesc430"
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "success",
              type: "STRING",
              require: "",
              normal: "",
              describe: "apiDocDesc.successDesc431"
            },
            {
              name: "reason",
              type: "STRING",
              require: "",
              normal: "",
              describe: "apiDocDesc.reasonDesc432"
            },
            {
              name: "message",
              type: "STRING",
              require: "",
              normal: "",
              describe: "apiDocDesc.messageDesc433"
            },
            {
              name: "total",
              type: "INT",
              require: "",
              normal: "",
              describe: "apiDocDesc.totalDesc434"
            },
            {
              name: "startPage",
              type: "INT",
              require: "",
              normal: "",
              describe: "apiDocDesc.startPageDesc435"
            },
            {
              name: "pageSize",
              type: "INT",
              require: "",
              normal: "",
              describe: "apiDocDesc.pageSizeDesc436"
            },
            {
              name: "baseList",
              type: "ARRAY",
              require: "",
              normal: "",
              describe: "apiDocDesc.baseListDesc437",
              children: [
                {
                  name: "warehouseCode",
                  type: "STRING",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.warehouseCodeDesc438"
                },
                {
                  name: "companyCode",
                  type: "STRING",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.companyCodeDesc439"
                },
                {
                  name: "itemCode",
                  type: "STRING",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.itemCodeDesc440"
                },
                {
                  name: "barcodes",
                  type: "STRING",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.barcodesDesc441"
                },
                {
                  name: "inventoryType",
                  type: "STRING",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.inventoryTypeDesc442"
                },
                {
                  name: "snapshotDate",
                  type: "DATE",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.snapshotDateDesc443"
                },
                {
                  name: "productDate",
                  type: "DATE",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.productDateDesc444"
                },
                {
                  name: "expireDate",
                  type: "DATE",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.expireDateDesc445"
                },
                {
                  name: "batchCode",
                  type: "STRING",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.batchCodeDesc446"
                },
                {
                  name: "produceCode",
                  type: "STRING",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.produceCodeDesc447"
                },
                {
                  name: "inventoryAge",
                  type: "INT",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.inventoryAgeDesc448"
                },
                {
                  name: "onHandQty",
                  type: "INT",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.onHandQtyDesc449"
                },
                {
                  name: "availableQty",
                  type: "INT",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.availableQtyDesc450"
                }
              ]
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        warehouseCode: "SH.001",
        customerid: "CS001",
        itemCode: "retry_1096043921",
        snapshotDate: "2025-01-20",
        startPage: 1,
        pageSize: 200
      },
      //返回示例
      responseCode: {
        logisticproviderid: "YL",
        traceId: "3dbb6c636378dd0b175ac8318e6796f5",
        responseitems: [
          {
            success: "true",
            reason: "",
            errorMsg: null,
            total: 6,
            startPage: 1,
            pageSize: 6,
            baseList: [
              {
                warehouseCode: "SH.001",
                companyCode: "CS001",
                itemCode: "retry_1096043921",
                barcodes: "retry_1096043921",
                inventorySts: "ZP",
                snapshotDate: "2025-01-20",
                productDate: null,
                expireDate: null,
                batchCode: null,
                produceCode: null,
                onHandQty: 80,
                availableQty: 20064,
                inventoryAge: 229
              },
              {
                warehouseCode: "SH.001",
                companyCode: "CS001",
                itemCode: "retry_1096043921",
                barcodes: "retry_1096043921",
                inventorySts: "CC",
                snapshotDate: "2025-01-20",
                productDate: null,
                expireDate: null,
                batchCode: null,
                produceCode: null,
                onHandQty: 100,
                availableQty: 20064,
                inventoryAge: 229
              },
              {
                warehouseCode: "SH.001",
                companyCode: "CS001",
                itemCode: "retry_1096043921",
                barcodes: "retry_1096043921",
                inventorySts: "ZP",
                snapshotDate: "2025-01-20",
                productDate: "2025-01-01",
                expireDate: "2025-01-01",
                batchCode: null,
                produceCode: null,
                onHandQty: 4,
                availableQty: 20064,
                inventoryAge: 15
              },
              {
                warehouseCode: "SH.001",
                companyCode: "CS001",
                itemCode: "retry_1096043921",
                barcodes: "retry_1096043921",
                inventorySts: "CC",
                snapshotDate: "2025-01-20",
                productDate: "2025-01-06",
                expireDate: "2025-01-06",
                batchCode: null,
                produceCode: null,
                onHandQty: 6,
                availableQty: 20064,
                inventoryAge: 15
              },
              {
                warehouseCode: "SH.001",
                companyCode: "CS001",
                itemCode: "retry_1096043921",
                barcodes: "retry_1096043921",
                inventorySts: "ZP",
                snapshotDate: "2025-01-20",
                productDate: "2025-01-01",
                expireDate: "2025-01-31",
                batchCode: "PC001",
                produceCode: "PH001",
                onHandQty: 10000,
                availableQty: 20064,
                inventoryAge: 12
              },
              {
                warehouseCode: "SH.001",
                companyCode: "CS001",
                itemCode: "retry_1096043921",
                barcodes: "retry_1096043921",
                inventorySts: "ZP",
                snapshotDate: "2025-01-20",
                productDate: "2025-01-01",
                expireDate: "2025-02-01",
                batchCode: "PC001",
                produceCode: "PH002",
                onHandQty: 10000,
                availableQty: 20064,
                inventoryAge: 12
              }
            ]
          }
        ]
      }
    }
  };
}
